import {Dimension, Metric} from "@/cube"

export function toKey(
  dataItem: {[key in Dimension | Metric]?: unknown},
  dimensions: Array<Dimension>
): string {
  return dimensions.map(dimension => dataItem[dimension]).join("::")
}
